// 亚冬会 customViewType:'GP'|'GC'；GP代表总的父赛程赛果；GC代表子赛程赛果；可以放到scheduleInfo里面
export default {
  data() {
    return {
      bigSportsList: [
        {
          id: 'ALP',
          CN: '高山滑雪',
          EN: '',
          routePageArr: [
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '个人成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'BTH',
          CN: '冬季两项',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'CCS',
          CN: '越野滑雪',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'CUR',
          CN: '冰壶',
          EN: '',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'IHO',
          CN: '冰球',
          EN: '',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'FSK',
          CN: '花样滑冰',
          EN: '',
          routePageArr: [
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '个人成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
            D: [
              {
                startList: 'mode_14',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'SMT',
          CN: '冬季两项',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'SSK',
          CN: '滑雪登山',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_9',
              },
            ],
          },
        },
        {
          id: 'STK',
          CN: '短道速度滑冰',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_9',
                groupResult: 'mode_15',
                compreResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'SBD',
          CN: '单板滑雪',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'FRS',
          CN: '自由式滑雪',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_10',
              },
            ],
            D: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
      ],
    }
  },
}
